import Stomp from 'stompjs';
import store from '../store';
import { getToken } from './auth'



export function initWebSocket(id, websocketonmessage) {
  let socketUrl = '';
  if (process.env.NODE_ENV == 'development') {
    socketUrl = process.env.VUE_APP_WEBSOCKET_URL;
  } else {
    let host = window.location.host;
    let href = window.location.href;
    socketUrl = (href.indexOf('https:') == 0 ? 'wss://' : 'ws://') + host + '/ws';
  }
  return new Promise((resolve) => {
    const client = Stomp.client(socketUrl);
    client.debug = false
    client.connect({
      debug : false,
      host: 'hb-v3'
    }, () => {
      console.log("onConnect")
      client.subscribe('/queue/' + id, message => {
        websocketonmessage({
          data: message.body
        });
      })
      resolve(client)
    }, (error) => {
      console.log(error)
    })

  })
}


// 数字格式化
export function formatNumber(num) {
  return parseFloat(num).toFixed(8)
}

// 智能金额格式化 - 根据数值大小自动选择最佳显示格式
export function formatAmount(amount) {
  if (!amount) return '0'

  // 转换为字符串并去除前后空格
  let amountStr = String(amount).trim()

  // 如果是负数，取绝对值
  if (amountStr.startsWith('-')) {
    amountStr = amountStr.substring(1)
  }

  const num = parseFloat(amountStr)
  if (isNaN(num) || num === 0) return '0'

  // 如果是整数，直接返回
  if (num % 1 === 0) {
    return num.toString()
  }

  // 转换为字符串进行处理
  let numStr = num.toString()

  // 如果包含科学计数法，先转换为固定小数位
  if (numStr.includes('e') || numStr.includes('E')) {
    numStr = num.toFixed(8)
  }

  // 去除末尾的0
  numStr = numStr.replace(/\.?0+$/, '')

  // 如果小数位数少于等于4位，直接返回
  const decimalIndex = numStr.indexOf('.')
  if (decimalIndex === -1) {
    return numStr
  }

  const decimalPart = numStr.substring(decimalIndex + 1)

  // 如果小数位数少于等于4位，直接返回
  if (decimalPart.length <= 4) {
    return numStr
  }

  // 如果小数位数大于4位，检查前4位是否都是0
  const first4Decimals = decimalPart.substring(0, 4)
  if (first4Decimals === '0000') {
    // 前4位都是0，显示更多位数直到遇到非0数字
    let significantIndex = 0
    for (let i = 0; i < decimalPart.length; i++) {
      if (decimalPart[i] !== '0') {
        significantIndex = i
        break
      }
    }
    // 显示到第一个有效数字后1位，但最多8位
    const endIndex = Math.min(significantIndex + 2, 8)
    return numStr.substring(0, decimalIndex + 1 + endIndex)
  } else {
    // 前4位不全是0，显示4位小数
    return numStr.substring(0, decimalIndex + 5)
  }
}

export function getLocalName (key) {
  const langArr = [
    {
      name: '简体中文',
      key: 'zh-CN',
    },
    {
      name: '繁体中文',
      key: 'zh-TW',
    },
    {
      name: 'English',
      key: 'en',
    },
    // 哈萨克斯坦语
    {
      name: 'Русский',
      key: 'kk',
    },
    //   西班牙语
    {
      name: 'Español',
      key: 'es',
    },
    // 法语
    {
      name: 'Français',
      key: 'fr',
    },
    // 德语
    {
      name: 'Deutsch',
      key: 'de',
    },
    // 荷兰语
    {
      name: 'Nederlands',
      key: 'nl',
    },
    // 匈牙利语
    {
      name: 'Magyar',
      key: 'hu',
    },
    // 芬兰语
    {
      name: 'Suomi',
      key: 'fi',
    },
    // 挪威语
    {
      name: 'Norsk',
      key: 'no',
    },
    // 意大利语
    {
      name: 'Italiano',
      key: 'it',
    },
    // 葡萄牙语
    {
      name: 'Português',
      key: 'pt',
    },
    // 俄语
    {
      name: 'Pусский',
      key: 'ru',
    },
    //   土耳其语
    {
      name: 'Türkçe',
      key: 'tr',
    },
    // 韩语
    {
      name: '한국어',
      key: 'ko',
    },
    // 日语
    {
      name: '日本語',
      key: 'ja',
    },
    // 越南语
    {
      name: 'Tiếng Việt',
      key: 'vi',
    },
    // 印尼语
    {
      name: 'Bahasa Indonesia',
      key: 'id',
    },
    // 马来语
    {
      name: 'Bahasa Melayu',
      key: 'ms',
    },
    // 泰语
    {
      name: 'ภาษาไทย',
      key: 'th',
    },
    // 阿拉伯语
    {
      name: 'العربية',
      key: 'ar',
    },
    // 希伯来语
    {
      name: 'עברית',
      key: 'he',
    },
    // 印地语
    {
      name: 'हिन्दी',
      key: 'hi'
    }
  ]
  const lang = langArr.find(item => item.key === key)
  console.log('localName')
  console.log(lang)
  return lang ? lang.name : ''
}

// 默认语言
export function getDefaultLanguage () {
  // 如果用户手动设置过语言，优先使用保存的语言
  const savedLanguage = localStorage.getItem('locale');
  if (savedLanguage) {
    return savedLanguage;
  }
  
  // 否则根据系统语言自动适配
  const language = navigator.language
  const clientLanguage = (language != 'zh-CN' && language != 'zh-TW') ? language.substring(0, 2) : language
  const supportedLanguages = [
    'zh-CN',
    'zh-TW',
    'ar',
    'en',
    'es',
    'fr',
    'id',
    'ja',
    'ko',
    'pt',
    'ru',
    'th',
    'he',
    'tr',
    'hi',
    'vi',
    'de',
    'nl',
    'hu',
    'fi',
    'no',
    'it',
    'kk',
    'ms'
  ]
  
  // 如果系统语言在支持列表中，使用系统语言，否则默认使用英文
  const local = supportedLanguages.indexOf(clientLanguage) > -1 ? clientLanguage : 'en'
  return local
}

export function resetEmail(email) {
  if (!email) {
    return ''
  }
  let newEmail = ''
  let pre = email.substring(0, email.indexOf('@'))
  if (pre.length > 4) {
    pre = pre.substring(0, 2) + '****' + pre.substring(pre.length - 2)
  } else {
    pre = pre.substring(0, 1) + '****' + pre.substring(pre.length - 1)
  }
  newEmail = pre + email.substring(email.indexOf('@'))
  return newEmail
}

export function resetName(name) {
  if (!name) {
    return ''
  }
  let newName = ''
  if (name.length > 2) {
    newName = name.substring(0, 2) + '****'
  } else {
    newName = name.substring(0, 1) + '****'
  }
  return newName
}

export function sortByField(list, fieldName, order = 'asc') {
  return list.sort((a, b) => {
    if (a[fieldName] < b[fieldName]) {
      return order === 'asc' ? -1 : 1;
    }
    if (a[fieldName] > b[fieldName]) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  });
}
